"use client"

import React from "react"

interface HeaderSectionProps {
  title: string
  subtitle: string
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ title, subtitle }) => {
  return (
    <div className="mb-4 mt-3 w-full flex-none">
      <h1 className="mb-4 text-left font-manrope font-bold text-nelo-blue" style={{ fontSize: "32px", lineHeight: "1.2" }}>
        {title}
      </h1>
      <p className="text-left font-nunito text-gray-600" style={{ fontSize: "16px" }}>
        {subtitle}
      </p>
    </div>
  )
}

export default HeaderSection
